import { APP_INITIALIZER, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppComponent } from './app.component';
import { AppinitService, init_app } from './appinit.service';
import { ChangepasswordComponent } from './changepassword/changepassword.component';
import { CoreModule } from './core/core.module';
import { GmsLoginComponent } from './gms-login/gms-login.component';
import { GmsLogoutComponent } from './gms-logout/gms-logout.component';
import { GmsMainRoutingModule } from './gms-main-routing/gms-main-routing.module';
import { GmsNavMenuComponent } from './gms-nav-menu/gms-nav-menu.component';
import { GmsWelcomeComponent } from './gms-welcome/gms-welcome.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { SharedModule } from './shared/shared.module';
// import { BreadcrumbModule } from 'xng-breadcrumb';
import { BreadcrumbComponent, BreadcrumbItemDirective } from 'xng-breadcrumb';

//import { GamesManagementMenuNavComponent } from './modules/games-management/games-management-menu-nav/games-management-menu-nav.component';
@NgModule({
  declarations: [
    AppComponent,
    GmsLoginComponent,
    GmsWelcomeComponent,
    PageNotFoundComponent,
    GmsNavMenuComponent,
    GmsLogoutComponent,
    ChangepasswordComponent
    // GamesManagementMenuNavComponent
  ],
  imports: [
    BrowserModule,
    NgbModule,
    ReactiveFormsModule,
    CoreModule,
    SharedModule,
    GmsMainRoutingModule,
    BrowserAnimationsModule,
    // BreadcrumbModule
    BreadcrumbComponent,
    BreadcrumbItemDirective
  ],
  providers: [AppinitService, { provide: APP_INITIALIZER, useFactory: init_app, deps: [AppinitService], multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule { }
